import CheckIcon from "@hub/assets/check.svg";
import { ApplicationType } from "@hub/models/elements/application-type";
import { Framework } from "@hub/models/elements/framework";
import { ProgrammingLanguage } from "@hub/models/elements/programming-language";
import { Topic } from "@hub/models/elements/topic";
import React from "react";
import styles from "./filter-option.module.css";

interface FilterOptionProps {
  data: ApplicationType | ProgrammingLanguage | Framework | Topic;
  selectOption: (value: string) => void;
  checked: boolean;
}

export const FilterOption: React.FC<FilterOptionProps> = ({
  data,
  selectOption,
  checked,
}) => {
  const { value, displayName } = data;

  const handleSelection = () => {
    selectOption(value);
  };

  return (
    <button className={styles.filterOption} onClick={handleSelection}>
      <div
        className={`${styles.filterOption__checkbox} ${
          checked ? styles.checked : ""
        }`}
      >
        {checked && <CheckIcon />}
      </div>
      <span className={styles.filterOption__label}>{displayName}</span>
    </button>
  );
};
